import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getRuleExecutions = createAsyncThunk("ruleExecutions/getRuleExecutions", async (payload) => {
  try {
    const response = await magnifiAPI.getRuleExecutions(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const listRuleExecutionFilters = createAsyncThunk(
  "ruleConfiguration/listRuleExecutionFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.listRuleExecutionFilters(payload);

      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
